var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loadingContainer",staticClass:"ask-answer-stream"},[_c('AskMarkdownRenderer',{attrs:{"markdown":_vm.answerStream,"hovered":_vm.hoveredLink},on:{"md-event":_vm.handleMarkdownEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }